import { createStyles } from 'antd-style';

const useStyles = createStyles(({ token }) => ({
  contentBox: {
    padding: 16,
    borderRadius: 8,
    background: token.colorFillAlter,
    border: `1px solid ${token.colorBorderSecondary}`,
    minHeight: 120,
    lineHeight: 1.6,
    wordBreak: 'break-word',
    '& .markdown-body': {
      fontSize: token.fontSize,
      lineHeight: token.lineHeight,
    },
    '& .markdown-body p:last-child': {
      marginBottom: 0,
    },
    '& .markdown-body pre': {
      marginBottom: 12,
    },
  },
}));

export default useStyles;
